import React, { useEffect } from "react";
import { GlassesIcon } from "./GlassesIcon";

export default function Splash({ onDone, durationMs = 4200 }) {
  useEffect(() => {
    const t = setTimeout(onDone, durationMs);
    return () => clearTimeout(t);
  }, [onDone, durationMs]);
  return (
    <div className="splash-wrap" data-testid="splash-screen">
      <div className="splash-glasses">
        <GlassesIcon size={120} stroke="#f5f3ef" strokeWidth={2.5} />
      </div>
      <div style={{ textAlign: "center" }}>
        <div className="h-display" style={{ fontSize: "1.85rem" }}>
          Welcome to POCKET TA AI
        </div>
        <div className="h-eyebrow" style={{ marginTop: "0.75rem" }}>
          LEVERAGING AI FOR THE REST OF US
        </div>
      </div>
    </div>
  );
}
